




























































/* eslint-disable no-unused-vars */
import BaseComponent from '@/components/BaseComponent';
import { Component, Prop } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';
/* eslint-enable no-unused-vars */

@Component
export default class PasswordChange extends BaseComponent {
    @Prop({ default: false }) private is_display!: boolean;
    private passwordData: any = {};
    private showCurrentPassword: boolean = false; // 現在のパスワード表示
    private showNewPassword: boolean = false; // パスワード表示
    private showConfirmPassword: boolean = false; // パスワード確認表示

    get refs(): any {
        return this.$refs;
    }

    private closeDialog() {
        // 入力内容のリセット
        this.refs.passwordForm.reset();
        this.$emit('closeDialog');
    }

    private async passwordChange(user_id: string) {
        if (this.refs.passwordForm.validate() === false) {
            // 入力チェックで不備あり判定の為、後続処理は行わない
            return;
        }

        try {
            // Loading画面を表示する
            this.$store.dispatch('common/setLoadingStateAc', true);

            let params: any = {
                login_user_id: Number(this.userId),
                target_user_id: Number(user_id),
                current_password: this.passwordData.current_password,
                new_password: this.passwordData.new_password,
                password_confirm: this.passwordData.password_confirm,
            };
            const resp: AxiosResponse<any> = await this.$http.post('password_change.php', params, {
                headers: { token: this.token },
            });

            switch (resp.data.result) {
                case 'SUCCESS':
                    this.closeDialog();
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'success',
                        timeout: 5000,
                        message: 'パスワード変更成功',
                        return_flg: false,
                    });
                    break;
                case 'VALIDATION_ERROR':
                    // バリデーションエラーメッセージをセット
                    this.validationErrors = resp.data.errors;
                    break;
                case 'SESSION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 3000,
                        message: 'ログイン期限が終了しました。再度ログインして下さい。',
                        return_flg: true,
                    });
                    break;
                case 'AUTH_ERROR':
                case 'AUTHORITY_ERROR':
                case 'SAVE_FAILED_ERROR':
                case 'DBCONNECTION_ERROR':
                case 'DATA_NOTFOUND_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 5000,
                        message: 'パスワード変更失敗',
                        return_flg: false,
                    });
                    break;
            }
        } catch (error) {
            this.$store.dispatch('common/setAlertParamsAc', {
                is_display: true,
                type: 'error',
                timeout: 5000,
                message: 'パスワード変更失敗',
                return_flg: false,
            });
        } finally {
            // Loading画面を非表示にする
            this.$store.dispatch('common/setLoadingStateAc', false);
        }
    }
}
